"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockEditableType = void 0;
var BlockEditableType;
(function (BlockEditableType) {
    BlockEditableType["NormalBlock"] = "NormalBlock";
    BlockEditableType["CallRemoteScriptSubBlock"] = "CallRemoteScriptSubBlock";
})(BlockEditableType = exports.BlockEditableType || (exports.BlockEditableType = {}));
